export default __webpack_public_path__ + "static/media/avatar4.2a4ba26c.png";